<template>
  <div id="app">
    <!-- 使用路由视图显示当前路由对应的组件 -->
    <router-view />
  </div>
</template>

<script>
// 移除直接导入的HomePage组件，改为通过路由管理
export default {
  name: 'App'
}
</script>

<style scoped>
#app {
  width: 100%;
  min-height: 100vh;
}
</style>